import { render, staticRenderFns } from "./EditNegative.vue?vue&type=template&id=36376c2d&scoped=true&"
import script from "./EditNegative.vue?vue&type=script&lang=js&"
export * from "./EditNegative.vue?vue&type=script&lang=js&"
import style0 from "./EditNegative.vue?vue&type=style&index=0&id=36376c2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36376c2d",
  null
  
)

export default component.exports